import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AddressFields, AddressType, Constant, EnabledCountryCodes } from 'src/app/@shared/constants/Constant';
import { ItineraryService } from 'src/app/service/itinerary.service';
import { MemberService } from 'src/app/service/member.service';
import { AddContact } from 'src/app/service/service-request';
import { ICityViewModel, StateViewModel } from 'src/app/service/state.model';
import { VendorService } from 'src/app/service/vendor.service';
declare var $: any;
@Component({
  selector: 'app-add-contact',
  templateUrl: './add-contact.component.html',
  styleUrls: ['./add-contact.component.css'],
})
export class AddContactComponent implements OnInit {
  @Input() buId: string;
  @Input() type: string;
  @Output() fetchAddedContact = new EventEmitter();
  @Output() closeModel = new EventEmitter();
  @Input() isShowTemContactButton: boolean;
  @Input() isPopOpen: boolean;
  public config = {
    displayKey: 'name',
    search: true,
    placeholder: 'Add New Member',
    height: '500px',
  };
  public contact: AddContact = {
    Id: '',
    contactType: '',
    firstName: '',
    middleName: '',
    lastName: '',
    emailId: '',
    homeNumber: '',
    workNumber: '',
    cellNumber: '',
    address: {
      addressType: '00000000-0000-0000-0000-000000000000',
      countryId: '00000000-0000-0000-0000-000000000000',
      stateId: '00000000-0000-0000-0000-000000000000',
      cityId: '00000000-0000-0000-0000-000000000000',
      streetAddress: '',
      zipcode: '',
      addressLocationType: null,
      isGlobal: true,
      businessUnitId: null,
    },
    isTemporary: false,
  };
  public loader: boolean = false;
  public user: any;
  public AddressType: string[] = AddressType;
  public selectMemberLoader: boolean = false;
  public isSaveBtnDisabled: boolean = false;
  constructor(
    private toastr: ToastrService,
    private memberService: MemberService,
    private _vendorService: VendorService,
    private itineraryService: ItineraryService,
  ) {}

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
  }
  ngOnChanges() {
    this.loader = true;
    this.selectMemberLoader = true;
    this.getStateList();
    this.getAllAddressType();
    this.getMemberList();
  }
  public stateList: StateViewModel[] = [];
  getStateList() {
    this._vendorService.getStateList().subscribe(
      (response) => {
        this.loader = false;
        this.stateList = response;
      },
      (error) => {
        this.loader = false;
      },
    );
  }
  public stateId: any;
  public cityList: any = [];
  public addressTypes: any;

  getAllAddressType() {
    this.memberService.getAllAddressType().subscribe((response) => {
      this.addressTypes = response;
    });
  }
  getCityByState(event, flag?) {
    this.isCityButtonShow = true;
    this.stateId = event;
    this._vendorService.getCityByState(this.stateId).subscribe((response) => {
      this.cityList = response;
      if (this.cityList.length > 0 && flag != undefined) {
        this.contact.address.cityId = this.cityList.find((x) => x.cityId == flag).cityId;
      }
    });
  }

  resetForm(addContactPerson: any) {
    addContactPerson.resetForm();
  }
  public memberList: any;
  getMemberList() {
    this._vendorService.getAllMemberList(this.buId).subscribe(
      (response) => {
        this.memberList = response;
        this.selectMemberLoader = false;
      },
      (error) => {
        this.selectMemberLoader = false;
      },
    );
  }
  saveContact(contactData, event) {
    if (event.form.valid) {
      this.isSaveBtnDisabled = true;
      this.loader = true;
      contactData['contactType'] = this.type;
      contactData['Id'] = this.buId;
      this.contact.address.businessUnitId = this.buId;
      this.contact.workNumber = this.contact.workNumber.replace(/[^0-9\s]/g, '');
      this.contact.workNumber = this.contact.workNumber.replace(/\s/, '');
      if (contactData.address.stateId == null || contactData.address.stateId == '') {
        contactData.address.stateId = '00000000-0000-0000-0000-000000000000';
        contactData.address.cityId = '00000000-0000-0000-0000-000000000000';
      }
      if (contactData.address.streetAddress == null) contactData.address.streetAddress = '';
      if (contactData.address.streetAddress == null) contactData.address.streetAddress = '';
      this.memberService.addContact(contactData).subscribe(
        (response) => {
          this.hideAddContactForm();
          event.resetForm();
          this.loader = false;
          this.isSaveBtnDisabled = false;
          this.clearContactData();
          this.fetchAddedContact.emit(response);
          this.toastr.success('Contact Added Successfully!', 'Success!', {
            timeOut: 6000,
            positionClass: 'toast-top-center',
          });
        },
        (err) => {
          this.loader = false;
          this.toastr.warning('Unable to add the contact. Please try again.', 'Warning', {
            timeOut: 6000,
            positionClass: 'toast-top-center',
          });
          this.isSaveBtnDisabled = false;
        },
      );
    }
    this.isCityButtonShow = false;
    this.isShowAddCity = false;
  }

  private hideAddContactForm() {
    $('#addContactPerson').modal('hide');
  }

  closeContactModel() {
    this.isCityButtonShow = false;
    this.isShowAddCity = false;
    this.loader = false;
    this.closeModel.emit();
    //this.fetchAddedContact.emit();
    this.clearContactData();
  }
  clearContactData() {
    this.contact = {
      Id: '',
      contactType: '',
      firstName: '',
      middleName: '',
      lastName: '',
      emailId: '',
      homeNumber: '',
      workNumber: '',
      cellNumber: '',
      address: {
        addressType: '00000000-0000-0000-0000-000000000000',
        countryId: '00000000-0000-0000-0000-000000000000',
        stateId: '00000000-0000-0000-0000-000000000000',
        cityId: '00000000-0000-0000-0000-000000000000',
        streetAddress: '',
        zipcode: '',
        addressLocationType: null,
        businessUnitId: null,
        isGlobal: true,
      },
      isTemporary: false,
    };
  }
  selectMember(event) {
    this.contact.firstName = event.value.firstName;
    this.contact.middleName = event.value.middleName;
    this.contact.lastName = event.value.lastName;
    if (String(event.value.phoneNumber).length > 10) {
      this.contact.cellNumber = event.value.phoneNumber;
    } else if (String(event.value.phoneNumber).length == 10) {
      let n: string = '(' + String(event.value.phoneNumber).substr(0, 3);
      n = n + ') ';
      n = n + String(event.value.phoneNumber).substr(3, 3);
      n = n + '-' + String(event.value.phoneNumber).substr(6, 4);
      this.contact.cellNumber = n;
    }

    this.contact.address.streetAddress = event.value.streetAddress;
    this.contact.address.zipcode = event.value.zipcode;
    this.contact.address.stateId = event.value.stateId;
    this.contact.address.cityId = event.value.cityId;
  }
  public autoCompleteAddrInput: HTMLInputElement;
  public searchAddr: string;

  autoSearchAddress() {
    var autocomplete: any;
    var options = {
      componentRestrictions: { country: EnabledCountryCodes },
      fields: AddressFields,
    } as google.maps.places.AutocompleteOptions;
    this.autoCompleteAddrInput = document.getElementById('autocompleteAddress') as HTMLInputElement;
    autocomplete = new google.maps.places.Autocomplete(this.autoCompleteAddrInput, options);
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      var place = autocomplete.getPlace();
      if (place != null && place['adr_address'] != null) {
        this.autoSelectAddress(place['adr_address']);
      }
    });
  }
  private returnStateCode(parsedData: Document): string {
    const stateCode =
      parsedData.getElementsByClassName('region').length > 0 ? parsedData.getElementsByClassName('region')[0].innerHTML : null;
    return stateCode;
  }
  private returnZipCode(parsedData: Document): string {
    const zipCode: string =
      parsedData.getElementsByClassName('postal-code').length > 0
        ? parsedData.getElementsByClassName('postal-code')[0].innerHTML.substring(0, 5)
        : '';
    if (zipCode.length != 0 && zipCode.includes(' ')) return zipCode.substring(0, 3);
    else return zipCode;
  }

  private returnStreetAddress(parsedData: Document): string {
    const streetAddr: string =
      parsedData.getElementsByClassName('street-address').length > 0
        ? parsedData.getElementsByClassName('street-address')[0].innerHTML
        : '';
    return streetAddr;
  }

  private returnCityName(parsedData: Document): string {
    const cityName: string =
      parsedData.getElementsByClassName('locality').length > 0 ? parsedData.getElementsByClassName('locality')[0].innerHTML : '';
    return cityName;
  }

  private returnCountryName(parsedData: Document): string {
    const cityName: string =
      parsedData.getElementsByClassName('country-name').length > 0 ? parsedData.getElementsByClassName('country-name')[0].innerHTML : '';
    return cityName;
  }
  autoSelectAddress(str) {
    this.contact.address.streetAddress = '';
    this.contact.address.stateId = '';
    this.contact.address.cityId = '';
    this.contact.address.zipcode = '';
    var htmlAddr = str;
    var parser = new DOMParser();
    var parsedData: Document = parser.parseFromString(htmlAddr, 'text/html');
    var arr: HTMLCollectionOf<HTMLSpanElement> = parsedData.getElementsByTagName('span');
    this.contact.address.streetAddress = this.returnStreetAddress(parsedData);
    this.contact.address.zipcode = this.returnZipCode(parsedData);
    const stateCode = this.returnStateCode(parsedData);
    const cityName = this.returnCityName(parsedData);
    const countryName = this.returnCountryName(parsedData);
    var currentState = this.stateList.find((x) => x.stateCode == stateCode);
    if (currentState != null) {
      this.contact.address.stateId = currentState.stateId;
      this._vendorService.getCityByState(currentState.stateId).subscribe((response) => {
        this.cityList = response;
        var currentCity = this.cityList.find((x) => x.cityName == cityName);
        if (currentCity == null) {
          //   this.cityAdd.cityName = cityName;
          //   this.addCity();
        } else {
          this.contact.address.cityId = currentCity.cityId;
        }
      });
    }
  }
  public isCityButtonShow = false;
  public isShowAddCity = false;
  public cityAdd: ICityViewModel = {
    cityId: '00000000-0000-0000-0000-000000000000',
    id: '00000000-0000-0000-0000-000000000000',
    cityName: '',
    cityCode: '',
    stateId: '00000000-0000-0000-0000-000000000000',
  };
  addCity() {
    if (this.cityAdd.cityName != '') {
      this.cityAdd.stateId = this.contact.address.stateId;
      this.memberService.addCity(this.cityAdd).subscribe(
        (response) => {
          this.getCityByState(this.contact.address.stateId, response);
          this.isShowAddCity = false;
          this.clearCityData();
        },
        (err) => {
          this.toastr.warning('Unable to add the city for the contact. Please try again.', 'Warning', {
            timeOut: 6000,
            positionClass: 'toast-top-center',
          });
          this.loader = false;
        },
      );
    } else {
      this.isShowAddCity = false;
      this.clearCityData();
    }
  }
  clearCityData() {
    this.cityAdd = {
      cityId: '00000000-0000-0000-0000-000000000000',
      id: '00000000-0000-0000-0000-000000000000',
      cityName: '',
      cityCode: '',
      stateId: '00000000-0000-0000-0000-000000000000',
    };
  }
  clickDropDown(id) {
    $('#' + id + ' .search-container :input').focus();
  }
}
